<div class="flex items-center justify-center h-full ag-input-cell">
  <!-- *ngIf="display" -->
  <input
    class="align-center w-full"
    type="{{ type }}"
    [class.in-valid]="inValid"
    [(ngModel)]="value"
    (focusout)="onFocusOut()"
    (input)="onInput()"
  />
</div>
